"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redirectToOAuth = exports.RedirectToOAuth = exports.RedirectToOAuthActionType = exports.EspSyncOAuthActionType = void 0;

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-sdk/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var EspSyncOAuthActionType = (0, _namespacedKeyMirror.default)({
  REDIRECT_TO_OAUTH: null
}, 'esp-sync-oauth');
exports.EspSyncOAuthActionType = EspSyncOAuthActionType;
var RedirectToOAuthActionType = (0, _actions.createRequestTypes)(EspSyncOAuthActionType.REDIRECT_TO_OAUTH);
exports.RedirectToOAuthActionType = RedirectToOAuthActionType;
var RedirectToOAuth = (0, _actions.createRequestActions)(RedirectToOAuthActionType);
exports.RedirectToOAuth = RedirectToOAuth;
var redirectToOAuth = (0, _fluxActions.createAction)(EspSyncOAuthActionType.REDIRECT_TO_OAUTH, (0, _actions.mapPayloadTo)('espType', 'redirectUrl'));
exports.redirectToOAuth = redirectToOAuth;